<template>
  <div class="create-tag modal">
    <div class="modal__container">
      <form
        class="create-tag"
        @submit.prevent
      >
        <div class="modal__top">
          <h1>{{ $t('add_tag') }}</h1>
          <button
            class="modal__close-btn"
            @click="closeModal"
          >
            ✕
          </button>
        </div>

        <div class="modal__body">
          <div style="width: 100%;display: flex;align-items: center;justify-content: space-between;margin: 30px 0 10px;padding-bottom:20px;border-bottom: 2px solid grey">
            <p style="margin: 0;font-family: HalvarR;color: white">
              {{ $t('butch_apps') }}
            </p>
            <label class="switch">
              <input
                v-model="isButchApps"
                type="checkbox"
              >
              <span class="slider round" />
            </label>
          </div>
          <div class="modal__input-container">
            <label
              class="modal__label"
              style="position: relative"
              for="tagName"
            >
              {{ $t('tag_name') }}
              <input
                id="tagName"
                v-model="name"
                :class="{'valid-error': name && name.length < 3}"
                required
                class="modal__unput required name"
                type="text"
                :placeholder="$t('tag_name')"
                maxlength="50"
                minlength="3"
              >
              <p
                v-if="name && name.length < 3"
                style="position: absolute;bottom: -33px;font-family: 'HalvarR';color: #ff2a00;font-size: 12px;"
              >
                {{ $t('min_length_message') }}
              </p>
            </label>
            <label
              class="modal__label"
            >
              {{ $t('applications') }}
              <input
                v-if="isButchApps"
                v-model="AppsString"
                type="text"
                class="modal__input required"
                @input="processString"
              >
              <multiselect
                v-if="!isButchApps"
                v-model="selectApps"
                class="modal__select--single multiselect"
                label="name"
                track-by="name"
                :placeholder="$t('applications')"
                :options="appsList.data"
                :multiple="true"
                :searchable="true"
                :allow-empty="true"
              />
            </label>
            <label
              class="modal__label"
            >
              {{ $t('pushes') }}
              <multiselect
                v-model="selectNotifies"
                class="modal__select--single multiselect"
                label="name"
                track-by="name"
                :placeholder="$t('pushes')"
                :options="notifyList.data"
                :multiple="true"
                :searchable="true"
                :allow-empty="true"
              />
            </label>
          </div>
          <button
            class="modal__create-btn"
            :disabled="name.length < 3"
            :class="{'opacity-btn': name.length < 3}"
            type="button"
            @click="createTag"
          >
            {{ $t('create') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  name: 'AddTags',
  components: { Multiselect },
  // props: {
  //   appsList: {
  //     type: [Array, Object],
  //     required: true,
  //   },
  //   notifyList: {
  //     type: [Array, Object],
  //     required: true,
  //   },
  // },
  props: ['appsList', 'notifyList'],

  data() {
    return {
      name: '',
      selectApps: [],
      selectNotifies: [],
      isButchApps: false,
      AppsString: "",
      apps: this.appsList
    };
  },
  mounted() {
    console.log('apps', this.appsList);
    console.log('notify', this.notifyList);
    },
  methods: {
    processString() {
      const values = this.AppsString
        .split(";")
        .map((item) => item.trim())
        .filter((item) => item !== "");

      const uniqueIds = new Set();

      this.selectApps = values
        .map((value) => {
          const foundItem = this.appsList.data.find(
            (item) => item.name.toLowerCase() === value.toLowerCase()
          );
          return foundItem || null;
        })
        .filter((item) => item !== null)
        .filter((item) => {
          if (uniqueIds.has(item.id)) {
            return false;
          }
          uniqueIds.add(item.id);
          return true;
        });
    },
    getIds (arr) {
      return arr.map(app => app.id);
    },
    createTag() {
      if (!this.name && this.name.length < 3) {
        return;
      }
      this.$emit('create', {
        name: this.name,
        notify: this.getIds(this.selectNotifies),
        applications: this.getIds(this.selectApps),
      });
    },
    closeModal() {
      this.$emit('close');
    }
  },
};
</script>

<style lang="scss" scoped>
.create-tag {
  &.modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 111;
    background: #161616;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .modal {
    &__container {
      background: #242424;
      padding: 20px;
      border-radius: 10px;
      min-width: 600px;
      min-height: 200px;
      max-width: 800px;
    }

    &__top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      h1 {
        margin: 0
      }
    }

    &__body {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      gap: 10px
    }

    &__input-container {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;


      label {
        gap: 8px;

        &:has(.name) {
          width: 100%
        }
      }

      .required {
        margin-top: 0;
      }
    }

    &__close-btn {
      background: transparent;
      color: white;
      border: none;
      font-size: 24px;
      padding: 0;
    }

    &__create-btn {
      width: 200px;
      height: 40px;
      min-height: 40px;
      border-radius: 8px;
      background: #ff2a00;
      color: #fff;
      font-size: 16px;
      border: none;
      font-family: HalvarR;
    }
  }
}
</style>

<style lang="scss">
.create-tag {
  .multiselect__select {
    right: 0;
    top: 10px
  }

  .multiselect__tags {
    max-height: 190px;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .modal__body {
    max-height: 550px;
    overflow-y: unset !important;
  }
}
</style>